"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formsPlugin = void 0;
var builder_1 = require("./builder");
var formsPlugin = function () {
    return {
        name: 'forms',
        events: {
            legacyBuild: function (logic, input) {
                'forms' in input && input.forms && (0, builder_1.forms)(input.forms)(logic);
            },
        },
    };
};
exports.formsPlugin = formsPlugin;
//# sourceMappingURL=plugin.js.map